import 'regenerator-runtime/runtime';
import { LoadAppSettings } from './AppSettings';
import WarmupEnvironment from './EnvironmentWarmup';
import { LoadUserManager } from './auth/AuthService';
import { InitializeAnalytics } from './helpers/AnalyticsUtility';
import { RedirectAppAuthReturnIfNeeded } from './apps/components/ConnectionHelper';
import { enableMapSet } from 'immer';
import { InitializeSift } from './Sift';
import { InitializeRaygun } from './helpers/RaygunUtility';
import { InitializeRegion } from './helpers/RegionCodes';

export async function Startup() {
  InitializeRegion();
  await LoadAppSettings();
  InitializeSift();
  await WarmupEnvironment();
  RedirectAppAuthReturnIfNeeded();
  enableMapSet();
  await LoadUserManager();

  InitializeRaygun();
  InitializeAnalytics();
}
